import { render, staticRenderFns } from "./restaurantBranchForm.vue?vue&type=template&id=67c3b513&scoped=true&"
import script from "./restaurantBranchForm.vue?vue&type=script&lang=js&"
export * from "./restaurantBranchForm.vue?vue&type=script&lang=js&"
import style0 from "./restaurantBranchForm.vue?vue&type=style&index=0&id=67c3b513&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c3b513",
  null
  
)

export default component.exports